import * as React from "react";
import classNames from "classnames";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import LockIcon from "@material-ui/icons/Lock";

import { Dispatch } from "redux";
import { StoreState } from "../../reducers/root-reducer";
import { Table } from "../../api/tables";
import { Area } from "../../api/areas";
import { GRIDH, GRIDV } from "../admin-settings/table-layout-composer/composer";

interface State {
	tables: Table[];
}

export interface MiniPlanProps {
	area: Area;
	occupiedTableIds: string[];
	locked: boolean;
}

interface ConnectedMiniPlanProps extends WithStyles<typeof styles> {
	tables: Table[];
}

type Props = MiniPlanProps & ConnectedMiniPlanProps;

export class MiniPlan extends React.Component<Props, State> {
	public state: State = {
		tables: []
	};

	public componentDidMount() {
		this.getTablesForArea(this.props.area.id);
	}

	public componentWillReceiveProps(nextProps: Props) {
		if (nextProps.area !== this.props.area) {
			this.getTablesForArea(nextProps.area.id);
		}
	}

	private getTablesForArea = (areaId: string) => {
		const { tables } = this.props;

		this.setState({
			tables: tables.filter(table => table.areaId === areaId)
		});
	};

	private renderTable = (table: Table) => {
		const { classes, occupiedTableIds } = this.props;
		const isOccupied = occupiedTableIds.indexOf(table.id) > -1;

		return (
			<div
				key={table.id}
				className={classes.table}
				style={{
					top: `${(table.layoutY * 100) / GRIDV}%`,
					left: `${(table.layoutX * 100) / GRIDH}%`,
					width: `${(table.layoutWidth * 100) / GRIDH}%`,
					height: `${(table.layoutHeight * 100) / GRIDV}%`,
					background: isOccupied ? "#D6D6D6" : "#03D000"
				}}
			/>
		);
	};

	public render() {
		const { classes, locked } = this.props;
		const { tables } = this.state;

		if (tables.length === 0) return null;

		return (
			<div className={classes.root}>
				<div
					className={classes.tableContainer}
					style={{
						paddingBottom: `${(GRIDV / GRIDH) * 100}%`
					}}
				>
					{tables.map(table => this.renderTable(table))}
				</div>
				<div className={classes.legend}>
					<div className={classes.legendGroup}>
						<div
							className={classes.legendColorField}
							style={{ background: "#D6D6D6" }}
						/>
						<Typography variant="caption">Belegt</Typography>
					</div>
					<div className={classes.legendGroup}>
						<div
							className={classes.legendColorField}
							style={{ background: "#03D000" }}
						/>
						<Typography variant="caption">Frei</Typography>
					</div>
				</div>
				<div
					className={classNames(classes.lockdownOverlay, {
						[classes.lockdownOverlayVisible]: locked
					})}
				>
					<LockIcon className={classes.lockdownIcon} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	tables: state.tables
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const styles = (theme: Theme) =>
	createStyles({
		root: {
			position: "relative"
		},
		tableContainer: {
			width: "100%",
			position: "relative"
		},
		table: {
			position: "absolute"
		},
		legend: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			marginTop: 15,
			paddingTop: 15,
			borderTop: "1px solid #E6E6E6"
		},
		legendGroup: {
			display: "flex",
			alignItems: "center",
			margin: "0 10px"
		},
		legendColorField: {
			width: 16,
			height: 16,
			marginRight: 5
		},
		legendLabel: {},
		lockdownOverlay: {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			background: "rgba(250, 250, 250, 0.8)",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			opacity: 0,
			transition: "opacity 0.3s ease"
		},
		lockdownOverlayVisible: {
			opacity: 1
		},
		lockdownIcon: {
			color: theme.palette.primary.main,
			width: 80,
			height: 80,
			filter: "drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2))"
		}
	});

export const ConnectedMiniPlan = withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MiniPlan)
);
